import imagePT from "../assets/factory/PT.png";
import imagePV from "../assets/factory/PV.png";
import imageMOTOSU from "../assets/factory/motosu.png";
import imageKANTO from "../assets/factory/kantou.png";
import imageFUKUOKA from "../assets/factory/fukuoka.png";
import imageKUMAMOTO from "../assets/factory/kumamoto.png";
import imageYAI from "../assets/factory/yai.png";
import imageBO from "../assets/backoffice/backoffice.png";
import imageSite from "../assets/factory/site.png";
import imageAll from "../assets/factory/all.png";
export const VIEW_ID_ALL_FACTORY = 0;
export const VIEW_ID_PT = 50111;
export const VIEW_ID_PV = 50112;
export const VIEW_ID_54 = 54;
export const VIEW_ID_5253 = 5253;
export const VIEW_ID_SITE = 9999;
export const viewsList = [
  {
    id: 0,
    category: "default",
    name: "全工場PT",
    image: imageAll,
  },
  {
    id: 50111,
    category: "factory",
    name: "本社・屋井PT",
    image: imagePT,
  },
  {
    id: 50112,
    category: "factory",
    name: "本社PV組立",
    image: imagePV,
  },
  {
    id: 54,
    category: "factory",
    name: "関東工場",
    image: imageYAI,
  },
  {
    id: 5253,
    category: "factory",
    name: "福岡・熊本工場",
    image: imageFUKUOKA,
  },
  // {
  //   id: 9999,
  //   category: "onSite",
  //   name: "現場組立",
  //   image: imageSite,
  // },
];
